export const MODULE_NAME = 'landing-pages';
export const LANDING_PAGES_ROUTE = `/${MODULE_NAME}`;
